import { combineReducers } from 'redux';
import { MemberReducer } from './memberReducer';

const rootReducer = combineReducers({

  MemberReducer: MemberReducer
})

export default rootReducer